import { createContext, useContext, useEffect, useState } from 'react';
import { login } from '../services/bioplus-services/auth';
import Service from '../services/bioplus-services/service';
import user from '../services/bioplus-services/user';

export const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(undefined);
  // const [accessControl, setAccessControl] = useState(undefined);

  useEffect(() => {
    if (!session) {
      setSession(Service.getSession());
    }
  }, []);

  // const handleLogin = async (username, password) => {
  //   try {
  //     const s = await login(username, password);

  //     if (s) {
  //       // const res = await getUserLevelAccessControl(s?.token);
  //       const res = await user.getRoles();
  //       const roles = res ?? [];
  //       if (
  //         (roles?.length ?? 0) > 0 &&
  //         roles.every(
  //           (role) =>
  //             // role?.role !== 'VISITOR' &&
  //             role?.role !== 'EMPLOYEE' && (role?.roleAccess === 'B' || role?.roleAccess === 'D')
  //         )
  //       ) {
  //         setSession(s);
  //         localStorage.setItem('session', JSON.stringify(s));
  //         return s;
  //       } else {
  //         setSession(undefined);
  //         return undefined;
  //       }

  //       // if (res) {
  //       //   setAccessControl(res);
  //       //   if (res?.some((item) => item?.desktopAccess === true)) {
  //       //     setSession(s);
  //       //     localStorage.setItem('session', JSON.stringify(s));
  //       //     return s;
  //       //   } else {
  //       //     setSession(undefined);
  //       //     return undefined;
  //       //   }
  //       // }
  //     }
  //   } catch (e) {
  //     setSession(undefined);
  //     throw e;
  //   }

  //   return undefined;
  // };

  // const handleLogin = async (username, password, isInvite) => {
  //   try {
  //     const s = await login(username, password);

  //     if (s) {
  //       const res = await user.getRoles();
  //       const roles = res ?? [];

  //       if ((roles?.length ?? 0) > 0) {
  //         const isAuthorized = isInvite
  //           ? roles.every((role) => {
  //               // VISITOR role is always allowed for invites
  //               if (role?.role === 'VISITOR') {
  //                 return true;
  //               }

  //               // For non-VISITOR roles, check both conditions
  //               return (
  //                 role?.role !== 'EMPLOYEE' &&
  //                 (role?.roleAccess === 'B' || role?.roleAccess === 'D')
  //               );
  //             })
  //           : roles.every(
  //               (role) =>
  //                 role?.role !== 'EMPLOYEE' &&
  //                 (role?.roleAccess === 'B' || role?.roleAccess === 'D')
  //             );

  //         if (isAuthorized) {
  //           setSession(s);
  //           localStorage.setItem('session', JSON.stringify(s));
  //           return s;
  //         }
  //       }

  //       setSession(undefined);
  //       return undefined;
  //     }
  //   } catch (e) {
  //     setSession(undefined);
  //     throw e;
  //   }

  //   return undefined;
  // };

  const handleLogin = async (username, password, isInvite) => {
    try {
      const s = await login(username, password);

      if (s) {
        const res = await user.getRoles();
        const roles = res ?? [];

        if ((roles?.length ?? 0) > 0) {
          const isAuthorized = roles.every(
            (role) => role?.roleAccess === 'B' || role?.roleAccess === 'D'
          );

          if (isAuthorized) {
            setSession(s);
            localStorage.setItem('session', JSON.stringify(s));
            return s;
          }
        }

        setSession(undefined);
        return undefined;
      }
    } catch (e) {
      setSession(undefined);
      throw e;
    }

    return undefined;
  };

  const handleLogout = (session) => {
    setSession(undefined);
    localStorage.removeItem('session');
  };

  const value = {
    session,
    login: handleLogin,
    logout: handleLogout,
    // accessControl,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
